import {useParams} from 'react-router'

import {UrlParams} from '../params'

export const useTryGetUrlParam = (param: keyof UrlParams) => {
  const obtainedParams = useParams<Partial<UrlParams>>()
  const parameter = obtainedParams[param]
  return parameter
}
